export default __webpack_public_path__ + "static/media/bg_88802663.7f57a080.webp";